export const companyRecipients = [
    { value: 'rp@newspark.nl', label: 'Newspark' },
    { value: 'elisabeth.stevens@everybodyfrank.com', label: 'Everybody Frank' },
    { value: 'invoice@bluegroup-it.nl', label: 'Blue Group' },
    { value: 'administratie@d2win.nl', label: 'D2WIN' },
    { value: 'administratie@acda-rpa.nl', label: 'Acda Consultancy' },
    { value: 'administratie@bluenexus.nl', label: 'BlueNexus' },
    { value: 'administratie@blynkt.nl', label: 'Blynkt' },
]
